import { ReactNode, createContext, useContext, useState } from "react";

type MuiDataGridEditingContextType = {
  isEditing: boolean;
  setIsEditing: (isEditing: boolean) => void;
  waitEditingFalse: () => Promise<void>;
};

const MuiDataGridEditingContext = createContext<MuiDataGridEditingContextType>({
  isEditing: false,

  setIsEditing: () => {},

  waitEditingFalse: () => Promise.resolve(),
});

const sleep = (msec: number) => new Promise((resolve) => setTimeout(resolve, msec));

export const MuiDataGridEditingProvider = ({ children }: { children: ReactNode }) => {
  const [isEditing, setIsEditing] = useState(false);

  // editingがfalseになるまで、loopで待つ
  const waitEditingFalse = async () => {
    const startTime = Date.now();
    while (isEditing) {
      if (Date.now() - startTime > 1500) {
        // 1.5秒待ってもfalseにならない場合は強制的にfalseにする(多分同期終わってると思うのと、もともとなかったときと同じ処理をするだけなので)
        // throw new Error("Editing is not resolved within 2.5 seconds");
        setIsEditing(false);
        break;
      }
      await sleep(200);
    }
    // NOTE: isEditingのfalseだけで行くとDataGrid -> stateへのsyncが非同期で500ms位ラグがあってうまくいかないようなので追加で1秒待つ
    // TODO: 多分そもそもDatagrid -> stateへのsyncの部分をどうにかしたいが...パフォーマンス考えるとああいう実装になるのかな。きちんとした調査が必要。
    await sleep(1000);
  };

  return (
    <MuiDataGridEditingContext.Provider value={{ isEditing, setIsEditing, waitEditingFalse }}>
      {children}
    </MuiDataGridEditingContext.Provider>
  );
};

export const useMuiDataGridEditing = () => useContext(MuiDataGridEditingContext);
